"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Selectors = Selectors;
exports.SelectorsContainer = void 0;
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _propTypes = _interopRequireDefault(require("prop-types"));
const SelectorsContainer = exports.SelectorsContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "SelectorsContainer",
  class: "pl-s18hidn1"
});

/**
 * Selectors component.
 *
 * @param {Object} props React props
 * @param {node} props.children Children elements
 * @returns {React.ReactElement} Selectors layout
 * @public
 */
function Selectors({
  children
}) {
  return /*#__PURE__*/_react.default.createElement(SelectorsContainer, {
    "data-cy": "selectors"
  }, children);
}
Selectors.propTypes = {
  children: _propTypes.default.array
};